if (document.getElementsByClassName('js-bgShift')[0]) {
  bgShift()
}

// 背景色を切り替える

function bgShift() {
  /*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
  // 画面に入った監視対象に.animatedを付加
  // Intersection Observer
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-50% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-bgShift')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target

        const target = entryItem.dataset.target
        const no = entryItem.dataset.no

        document.querySelectorAll('.js-bgShift--' + target).forEach((element) => {
          element.classList.remove('active')
        })
        document.querySelectorAll('.js-bgShift--' + target + '-' + no).forEach((element) => {
          element.classList.add('active')
        })
      }
    }
  }
}
